import { BroadcastChannel } from 'broadcast-channel';

export const CHANNELS = {
    MAIN: 'rvlife_campgrounds'
};

// Dictionary to store channel instances
const channelInstances = {};

export const getChannelInstance = (channelName) => {
    if (!channelInstances[channelName]) {
        channelInstances[channelName] = new BroadcastChannel(channelName, {
            idb: {
                onclose: () => {
                    channelInstances[channelName].close();
                    delete channelInstances[channelName];
                },
            },
        });
    }
    return channelInstances[channelName];
};

export const broadcast = (channelName, message) => {
    const channel = getChannelInstance(channelName);
    channel.postMessage(message);
};

export const subscribe = (channelName, callback) => {
    const channel = getChannelInstance(channelName);
    channel.onmessage = callback;
};

export const unsubscribe = (channelName) => {
    const channel = getChannelInstance(channelName);
    channel.close();
    delete channelInstances[channelName];
};
